<template>
  <section class="vh-100 login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-5 px-0 d-none d-sm-block triangle-left">
          <div class="login__logo">
            <!-- <h1>Ecoles</h1> -->
            <!-- <p>Platforme Education <br />Culture & Sport</p> -->
            <img 
              src="../../assets/icons/logo-ecole.svg" 
              alt="logo" 
            > 
          </div>
        </div>
        <div class="col-sm-7 g-0 text-black skew-triangle">
          <div class="login__connexion">
            <div class="px-5 ms-xl-4 login__connexion__logo">
              <!-- <h2 class="h1 fw-bold mb-0">Ecoles</h2> -->
            </div>

            <div
              class="d-flex align-items-center h-custom-2 px-5 ms-xl-4 mt-5 pt-5 pt-xl-0 mt-xl-n5"
            >
              <form style="width: 23rem">
                <h3 class="mb-3 pb-3" style="letter-spacing: 1px">{{ $t('login.renitialiser') }}</h3>
                <div class="alert" role="alert" v-if="validationPassword">
                  <p>
                    {{
                      $t("authentification.validationPassword")
                    }}
                  </p>
                </div>
                <div class="alert alert-danger" role="alert" v-if="invalidMail">
                  <p>{{ $t("authentification.invalidMail") }}</p>
                </div>
                <div class="alert alert-danger" role="alert" v-if="mailNotAlloawed">
                  <p>
                    {{
                    $t(
                    "authentification.mailNotAllowed"
                    )
                    }}
                  </p>
                </div>

                <div class="form-outline input-wrapper mb-4">
                  <div class="input-icon-wrapper input-icon-wrapper--login">
                    <input
                      type="email"
                      id="form2Example18"
                      class="form-control form-control-lg style-input1"
                      v-model="email"
                      placeholder="Adresse email"
                      :class="
                                                v$.email.$error === true
                                                    ? 'text-fields-error'
                                                    : ''
                                            "
                      autocomplete="off"
                    />
                  </div>

                  <span
                    class="invalid-feedback"
                    v-if="v$.email.$error"
                  >{{ v$.email.$errors[0].$message }}</span>
                </div>

                <div class="pt-1 mb-4 button-login">
                  <button
                    @click.prevent="submitForm"
                    class="btn btn-outline-primary button"
                    :disabled="loading"
                  >
                    {{ $t('button.send') }}
                    <i class="icon-Arrow"></i>
                  </button>
                </div>

                <p class="small mb-5 pb-lg-2">
                  <router-link :to="{ name: 'Login' }">{{$t('login.retourPage') }}</router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import useValidate from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";
import AuthService from "../../services/auth.service";
export default {
  name: "Password",
  components: {},
  data() {
    return {
      v$: useValidate(),
      loading: false,
      email: "",
      submited: false,
      validationPassword: false,
      invalidMail: false,
      mailNotAlloawed: false
    };
  },
  validations() {
    return {
      email: {
        required: helpers.withMessage("Email is required", required),
        email
      }
    };
  },
  computed: {},
  created() {},
  methods: {
    submitForm() {
      this.loading = true;
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        let data = {
          email: this.email
        };
        this.loading = true;

        AuthService.password(data)
          .then(response => {
            this.validationPassword = true;
            this.invalidMail = false;
            this.mailNotAlloawed = false;
            this.loading = false;
            this.submited = true;
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.invalidMail = true;
              this.mailNotAlloawed = false;
              this.validationPassword = false;
              this.loading = false;
            } else if (
              error.response.status === 403 ||
              error.response.status === 406
            ) {
              this.invalidMail = false;
              this.mailNotAlloawed = true;
              this.validationPassword = false;
              this.loading = false;
            }
            if (this.email === "") {
              this.invalidMail = false;
              this.mailNotAlloawed = false;
            }
            this.submited = false;
          });
      } else {
        this.loading = false;
      }
    }
  },
  watch: {}
};
</script>
